import { useRouter } from 'next/router'
import { Locations } from '@mc/track-event'
import { PurchaseNowCta } from './PurchaseNowCta'
import { shouldHideEnterpriseCTAInNav } from './utils'

export const NavActions = () => {
  const { pathname } = useRouter()

  if (shouldHideEnterpriseCTAInNav(pathname)) return <></>

  return <PurchaseNowCta className='mc-ml-8' location={Locations.NAVIGATION} />
}
